import { render } from "./TablaSolicitados.vue?vue&type=template&id=5a4fbdd8&ts=true"
import script from "./TablaSolicitados.vue?vue&type=script&lang=ts"
export * from "./TablaSolicitados.vue?vue&type=script&lang=ts"

import "./TablaSolicitados.vue?vue&type=style&index=0&id=5a4fbdd8&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__